import React from "react";

export function buildPlayerProfileLookup(players = []) {
  const map = new Map();
  (players || []).forEach((player) => {
    const id = String(player?.id ?? "").trim();
    if (!id) return;
    map.set(id, player?.profile_picture || null);
  });
  return map;
}

export function getProfilePictureSrc(profilePicture) {
  if (!profilePicture) return null;
  const raw = String(profilePicture).trim();
  if (!raw) return null;
  if (raw.startsWith("data:")) return raw;
  return `data:image/jpeg;base64,${raw}`;
}

function getInitials(name) {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
}

export function PlayerIdentityCell({ name, profilePicture, isDarkMode = false }) {
  const src = getProfilePictureSrc(profilePicture);

  return (
    <div className="flex min-w-0 items-center gap-2.5">
      <div
        className={`flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-full ${
          isDarkMode ? "bg-gray-700 ring-1 ring-gray-600" : "bg-slate-200 ring-1 ring-slate-200"
        }`}
      >
        {src ? (
          <img src={src} alt="" className="h-full w-full object-cover" />
        ) : (
          <span className={`text-[11px] font-semibold uppercase ${isDarkMode ? "text-gray-300" : "text-slate-600"}`}>
            {getInitials(name)}
          </span>
        )}
      </div>
      <span className="truncate font-medium">{name || "-"}</span>
    </div>
  );
}
